import * as React from "react";
import type { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
  fill?: string;
  isActive?: boolean;
}

export const SearchIcon = ({
  fill = "#6F747B",
  isActive,
  className,
  ...restProps
}: IconProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className || "flex-grow-0 flex-shrink-0 w-6 h-6 relative"}
    {...restProps}>
    <path
      fill={fill}
      className={className || `dark:${isActive
          ? "fill-primary"
          : "fill-caption group-hover:dark:fill-primary"
        }`}
      fillRule="evenodd"
      d="M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 14.32 4.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387A8 8 0 0 1 2 10Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SearchIcon;
